import React, { useEffect } from "react";
import easter from "./easter.svg";

interface TimedImageProps {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
}

const TimedImage = ({ isVisible, setIsVisible }: TimedImageProps) => {
  useEffect(() => {
    if (isVisible === false) return;
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [isVisible]);

  return <div>{isVisible && <img src={easter} alt="icon" style={{ width: "150px", height: "150px" }} />}</div>;
};

export default TimedImage;
